import type {StateProvider} from '@uirouter/angularjs';
import MessagesController from './messages.controller';
import template from './messages.tpl.ftl';

/*@ngInject*/
export default function messagesRoutes($stateProvider: StateProvider) {

    $stateProvider
        .state('messages', {
            url: '/messages',
            templateUrl: template,
            controller: MessagesController,
            controllerAs: '$ctrl'
        });
}